module.exports = __webpack_public_path__ + "media/svg/ai-3f9a92a4.svg";